function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Column, Spacer } from "@neru/ui";
import { OnBlurDetector } from "@neru/ui/src/components/OnBlurDetector/OnBlurDetector";
import React, { useCallback, useEffect, useState } from "react";
import { useIsReachingLimit } from "./hooks/useIsReachingLimit";
import { useIsTierUpdated } from "./hooks/useIsTierUpdated";
import { ReachLimitAnnouncement } from "./ReachLimitAnnouncement";
import { TierUpdatedAnnouncement } from "./TierUpdatedAnnouncement";
export var Announcements = function() {
    var _useState = _sliced_to_array(useState(false), 2), isExpanded = _useState[0], setIsExpanded = _useState[1];
    var _useIsReachingLimit = useIsReachingLimit(), hasLimitAnnouncement = _useIsReachingLimit.hasAnnouncement, isLimitAcknowledged = _useIsReachingLimit.isAcknowledged, setLimitAcknowledged = _useIsReachingLimit.setAcknowledged;
    var _useIsTierUpdated = useIsTierUpdated(), hasTierAnnouncement = _useIsTierUpdated.hasAnnouncement, isTierAcknowledged = _useIsTierUpdated.isAcknowledged, setTierAcknowledged = _useIsTierUpdated.setAcknowledged;
    var hasAnnouncement = hasLimitAnnouncement && !isLimitAcknowledged || hasTierAnnouncement && !isTierAcknowledged;
    var _useState1 = _sliced_to_array(useState(hasAnnouncement), 2), showDot = _useState1[0], setShowDot = _useState1[1];
    var acknowledge = useCallback(function() {
        setShowDot(false);
        setLimitAcknowledged();
        setTierAcknowledged();
    }, [
        setLimitAcknowledged,
        setTierAcknowledged
    ]);
    var togglePanel = useCallback(function() {
        setIsExpanded(function(isExpanded) {
            return !isExpanded;
        });
        if (isExpanded) {
            acknowledge();
        } else {
            setShowDot(false);
        }
    }, [
        acknowledge,
        isExpanded
    ]);
    var closePanel = useCallback(function() {
        if (isExpanded) {
            setIsExpanded(false);
            acknowledge();
        }
    }, [
        acknowledge,
        isExpanded
    ]);
    useEffect(function() {
        setShowDot(hasAnnouncement);
    }, [
        hasAnnouncement
    ]);
    var announcementsList = [];
    if (hasTierAnnouncement) {
        announcementsList.push({
            component: /*#__PURE__*/ _jsx(TierUpdatedAnnouncement, {}),
            key: "tier"
        });
    }
    if (hasLimitAnnouncement) {
        announcementsList.push({
            component: /*#__PURE__*/ _jsx(ReachLimitAnnouncement, {
                onClose: closePanel
            }),
            key: "limit"
        });
    }
    return /*#__PURE__*/ _jsxs(OnBlurDetector, {
        onBlur: closePanel,
        children: [
            /*#__PURE__*/ _jsx(Button, {
                "data-testid": "announcement",
                disabled: !hasAnnouncement,
                icon: "notification-on-line",
                layout: "ghost",
                onClick: togglePanel,
                shape: "pill",
                size: "condensed"
            }),
            showDot && /*#__PURE__*/ _jsx("div", {
                className: "\n            bg-alert-500 pointer-events-none absolute mt-4 ml-4 h-2 w-2 rounded\n          ",
                "data-testid": "announcement-dot"
            }),
            hasAnnouncement && isExpanded && /*#__PURE__*/ _jsx(Column, {
                className: "\n            bg-primary-800 dark absolute right-0 mt-9 mr-4 w-[430px] rounded-3xl\n            rounded-tr-none p-8\n          ",
                "data-testid": "announcement-panel",
                children: announcementsList.map(function(item, index) {
                    return /*#__PURE__*/ _jsxs(React.Fragment, {
                        children: [
                            index > 0 && /*#__PURE__*/ _jsx(Spacer, {
                                divider: true,
                                size: "xl",
                                vertical: true
                            }),
                            item.component
                        ]
                    }, item.key);
                })
            })
        ]
    });
};

//# sourceMappingURL=Announcements.js.map